<template>
  <div class="vd-gl-content">
    <a-icon type="info-circle" style="color: #40a9ff" />
    如果存在数据，重新上传会覆盖旧数据
    <a-row class="vd-toolbar">
      <a-col class="vd-toolbar-right vd-bar">
        <a-form layout="inline">
          <a-form-item>
            <input id="file" type="file" name="file" accept=".xls,.xlsx,.csv" />
          </a-form-item>
          <a-form-item>
            <a-button type="primary" @click="preview">预览</a-button>
            <a-button type="primary" style="margin-left: 8px" @click="handleOk">
              上传
            </a-button>
          </a-form-item>
        </a-form>
      </a-col>
    </a-row>

    <a-table row-key="id" :data-source="list" :columns="tableColumns"></a-table>
  </div>
</template>

<script>
import {
  auto_get_table_col,
  auto_get_table_source,
  auto_modify_table_source,
} from '@/api/auto'
import XLSX from 'xlsx'

export default {
  name: 'Table',
  data() {
    return {
      table_id: undefined,
      tableColumns: [],
      list: [],
      pagination: {
        total: 1,
        current: 1,
        pageSize: 10,
        hideOnSinglePage: true,
        onChange: (page) => {
          this.pagination.current = page
        },
      },
      form: {
        name: undefined,
        remark: undefined,
        due_time: undefined,
      },
    }
  },
  created() {
    if (!this.$HelperUtil.isEmpty(this.$route.query)) {
      this.table_id = parseInt(this.$route.query.id)
    }
    this.getColumns()
  },
  methods: {
    getColumns() {
      auto_get_table_col({ table_id: this.table_id }).then((res) => {
        if (res.code === 1) {
          this.tableColumns = res.col
          this.getData()
        } else {
          this.$message.warning(res.msg)
        }
      })
    },
    getData() {
      auto_get_table_source({ table_id: this.table_id }).then((res) => {
        if (res.code === 1) {
          this.list = res.list
        }
      })
    },
    preview() {
      // 获取文件流
      let file = document.getElementById('file').files[0]
      if (file === undefined) {
        this.$message.warning('请选择上传excel')
        return false
      }
      this.excelFn(file).then((res) => {
        console.log(res)
        this.list = res
      })
    },
    //  读取excel
    excelFn(file) {
      return new Promise((resolve, reject) => {
        const fileReader = new FileReader()
        fileReader.onload = (ev) => {
          const data = ev.target.result
          // 读取整个文件数据
          const workbook = XLSX.read(data, {
            type: 'binary',
          })
          // 取第一张表
          const wsname = workbook.SheetNames[0]
          // 生成json表格内容
          const ws = XLSX.utils.sheet_to_json(workbook.Sheets[wsname])
          resolve(ws)
        }
        fileReader.onerror = () => {
          reject(Error)
        }

        fileReader.readAsBinaryString(file)
      })
    },

    handleOk() {
      // 获取文件流
      let file = document.getElementById('file').files[0]
      if (file === undefined) {
        this.$message.warning('请选择上传excel')
        return false
      }
      this.excelFn(file).then((res) => {
        auto_modify_table_source({ table_id: this.table_id, data: res }).then(
          (resL) => {
            if (resL.code === 1) {
              this.getData()
              this.$message.success(resL.msg)
            } else {
              this.$message.warning(resL.msg)
            }
          }
        )
      })
    },
  },
}
</script>

<style scoped></style>
